/**
 * Send a google abalytics event
 * @param {object} param0 Params
 */
const gaEvent = ({
  eventCategory,
  eventAction,
  eventLabel,
}) => {
  if (window.ga) {
    window.ga('send', 'event', {
      eventCategory,
      eventAction,
      eventLabel,
    });
  }
};

export default gaEvent;



// WEBPACK FOOTER //
// ./src/utils/gaEvent.js